import AuthApi from './Auth';
import Base from './BaseApi';
import ContactsApi from './Contacts';
import EventsApi from './Events';
import PagesApi from './Pages';

class Api extends Base {
    auth: AuthApi;
    events: EventsApi;
    pages: PagesApi;
    contacts: ContactsApi;

    constructor(opts = {}) {
        super(opts);
        this.auth = new AuthApi(this.options);
        this.events = new EventsApi(this.options);
        this.pages = new PagesApi(this.options);
        this.contacts = new ContactsApi(this.options);
    }
}

export default Api;
